import React, { useState, ChangeEvent, FormEvent, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/admin.module.css';
import axios from 'axios';
import { URL_SERVER } from '../utils/Utils';
import secureLocalStorage from 'react-secure-storage';
import useAdminPanel from '../hooks/useAdminPanel';



const Administrador: React.FC = () => {

  const {
    users,
    organizations,
    roles,
    usersFiltered,
    rolesFiltered,
    organizationsFiltered,
    modalOpen,
    currentUser,
    currentRole,
    currentOrganization,
    searchUserTerm,
    searchRolesTerm,
    searchOrganizationTerm,
    setSearchUserTerm,
    setSearchRolesTerm,
    setSearchOrganizationsTerm,
    openModal,
    closeModal,
    handleUserChange,
    handleSearchUser,
    getFilteredUsers,
    submitUser,
    submitUserUpdate,
    deleteUser,
    restoreUser,
    setCurrentUser,
    handleSearchRoles,
    handleRoleChange,
    getFilteredRoles,
    submitRole,
    submitRoleUpdate,
    deleteRole,
    restoreRole,
    setCurrentRole,
    handleSearchOrganization,
    handleOrganizationChange,
    getFilteredOrganizations,
    submitOrganization,
    submitOrganizationsUpdate,
    deleteOrganization,
    restoreOrganization,
    setCurrentOrganization,
  } = useAdminPanel();


  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {/* Header */}
        <header className={styles.header}>
          <h1>Panel de Administración</h1>
          <div className={styles.actions}>
            <Link to="/" className={styles.linkButton} onClick={() => secureLocalStorage.clear()}>
              Cerrar sesión
            </Link>
            <Link to="/redirect" className={styles.linkButton}>
              Vista Principal
            </Link>
          </div>
        </header>

        {/* users */}
        <section className={styles.section}>
          <h2>Usuarias</h2>
          <div className={styles.buttonGroup}>
            <button onClick={() => openModal('createUser')} className={styles.button}>Crear</button>
            <button onClick={() => openModal('editUser')} className={styles.button}>Editar</button>
            <button onClick={() => openModal('softdeleteUser')} className={styles.button}>Eliminar</button>
            <button onClick={() => openModal('restoreUser')} className={styles.button}>Restaurar</button>
          </div>
        </section>

        {/* roles */}
        <section className={styles.section}>
          <h2>Roles</h2>
          <div className={styles.buttonGroup}>
            <button onClick={() => openModal('createRole')} className={styles.button}>Crear</button>
            <button onClick={() => openModal('editRole')} className={styles.button}>Editar</button>
            <button onClick={() => openModal('softdeleteRole')} className={styles.button}>Eliminar</button>
            <button onClick={() => openModal('restoreRole')} className={styles.button}>Restaurar</button>
          </div>
        </section>

        {/* organizations */}
        <section className={styles.section}>
          <h2>Organizaciones</h2>
          <div className={styles.buttonGroup}>
            <button onClick={() => openModal('createOrganization')} className={styles.button}>Crear</button>
            <button onClick={() => openModal('editOrganization')} className={styles.button}>Editar</button>
            <button onClick={() => openModal('softdeleteOrganization')} className={styles.button}>Eliminar</button>
            <button onClick={() => openModal('restoreOrganization')} className={styles.button}>Restaurar</button>
          </div>
        </section>

        {/* Modal */}
        {modalOpen && (
          <div className={styles.modalOverlay} onClick={closeModal}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
              <button className={styles.closeButton} onClick={closeModal}>&times;</button>

              {/* create Usuario */}
              {(modalOpen === 'createUser') && (
                <form onSubmit={submitUser} className={styles.form}>
                  <h3>{modalOpen === 'createUser' ? 'Crear Usuario' : 'Editar Usuario'}</h3>
                  <input name="name" placeholder="Nombre" onChange={handleUserChange} required />
                  <input name="surename" placeholder="Apellido" onChange={handleUserChange} required />
                  <input name="username" placeholder="Usuaria" onChange={handleUserChange} required />
                  <input name="password" type="password" placeholder="Contraseña" onChange={handleUserChange} required />
                  <input name="email" type="email" placeholder="Email" onChange={handleUserChange} required />
                  <select
                    name="role_id"
                    value={currentUser.role_id || ''}
                    onChange={handleUserChange}
                    required
                  >
                    <option value="" disabled>Selecciona un rol</option>
                    {roles.map(role => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </select>

                  <select
                    name="organization_id"
                    value={currentUser.organization_id || ''}
                    onChange={handleUserChange}
                    required
                  >
                    <option value="" disabled>Selecciona una organización</option>
                    {organizations.map(org => (
                      <option key={org.id} value={org.id}>
                        {org.name}
                      </option>
                    ))}
                  </select>

                  <button type="submit" className={styles.button}>Guardar</button>
                </form>
              )}
              {(modalOpen === 'editUser') && (
                <div className={styles.form}>
                  <h3>Buscar</h3>
                  <form onSubmit={getFilteredUsers} className={styles.form}>
                    <input
                      placeholder="Buscar usuaria..."
                      value={searchUserTerm}
                      onChange={(e) => setSearchUserTerm(e.target.value)}
                    />
                    <button type="submit" className={styles.button}>Buscar</button>

                    {currentUser.name != null &&
                      <h4>Última búsqueda:</h4>
                    }

                  </form>
                  <ul className={styles.list}>
                    {usersFiltered.map(u => (
                      <li key={u.id} className={styles.listItem}>
                        <span>{u.name} ({u.username})</span>
                        <button
                          onClick={() => setCurrentUser(u)}
                          className={styles.smallButton}
                        >

                          Seleccionar
                        </button>
                      </li>
                    ))}
                  </ul>
                  {currentUser.id && (
                    <form onSubmit={submitUserUpdate} className={styles.form}>
                      <h3>Editando</h3>
                      <input
                        name="name"
                        placeholder="Nombre"
                        value={currentUser.name || ''}
                        onChange={handleUserChange}
                        required
                      />
                      <input
                        name="surename"
                        placeholder="Apellido"
                        value={currentUser.surename || ''}
                        onChange={handleUserChange}
                        required
                      />
                      <input
                        name="username"
                        placeholder="Usuaria"
                        value={currentUser.username || ''}
                        onChange={handleUserChange}
                        required
                      />
                      <input
                        name="password"
                        type="password"
                        placeholder="Contraseña"
                        value={currentUser.password || ''}
                        onChange={handleUserChange}
                        required
                      />

                      <input name="email" type="email" placeholder="Email" onChange={handleUserChange} required />

                      <select
                        name="role_id"
                        value={currentUser.role_id || ''}
                        onChange={handleUserChange}
                        required
                      >
                        <option value="" disabled>Selecciona un rol</option>
                        {roles.map(role => (
                          <option key={role.id} value={role.id}>
                            {role.name}
                          </option>
                        ))}
                      </select>

                      <select
                        name="organization_id"
                        value={currentUser.organization_id || ''}
                        onChange={handleUserChange}
                        required
                      >
                        <option value="" disabled>Selecciona una organización</option>
                        {organizations.map(org => (
                          <option key={org.id} value={org.id}>
                            {org.name}
                          </option>
                        ))}
                      </select>

                      <button type="submit" className={styles.button}>Guardar</button>
                    </form>

                  )}
                </div>
              )}
              {/* softdelete Usuario */}
              {modalOpen === 'softdeleteUser' && (
                <div className={styles.form}>
                  <h3>Eliminar (desactivar)</h3>
                  <form onSubmit={getFilteredUsers} className={styles.form}>
                    <input
                      placeholder="Buscar usuaria..."
                      value={searchUserTerm}
                      onChange={(e) => setSearchUserTerm(e.target.value)}
                    />
                    <button type="submit" className={styles.button}>Buscar</button>


                    {currentUser.name != null &&
                      <h4>Última búsqueda:</h4>
                    }


                  </form>
                  <ul className={styles.list}>
                    {usersFiltered.map(u => (
                      <li key={u.id} className={styles.listItem}>
                        <span>{u.name} ({u.username})</span>
                        <button
                          onClick={() => setCurrentUser(u)}
                          className={styles.smallButton}
                        >

                          Seleccionar
                        </button>
                      </li>
                    ))}
                  </ul>
                  {currentUser.id && (
                    <div className={styles.confirmBox}>
                      <p>¿softdelete a {currentUser.name}?</p>
                      <div className={styles.buttonGroup}>
                        <button onClick={() => deleteUser(currentUser.id)} className={styles.button}>Sí, softdelete</button>
                        <button onClick={closeModal} className={styles.smallButton}>Cancelar</button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {modalOpen === 'restoreUser' && (
                <div className={styles.form}>
                  <h3>Restaurar</h3>
                  <form onSubmit={getFilteredUsers} className={styles.form}>
                    <input
                      placeholder="Buscar usuaria..."
                      value={searchUserTerm}
                      onChange={(e) => setSearchUserTerm(e.target.value)}
                    />
                    <button type="submit" className={styles.button}>Buscar</button>


                    {currentUser.name != null &&
                      <h4>Última búsqueda:</h4>
                    }


                  </form>
                  <ul className={styles.list}>
                    {usersFiltered.map(u => (
                      <li key={u.id} className={styles.listItem}>
                        <span>{u.name} ({u.username})</span>
                        <button
                          onClick={() => setCurrentUser(u)}
                          className={styles.smallButton}
                        >

                          Seleccionar
                        </button>
                      </li>
                    ))}
                  </ul>
                  {currentUser.id && (
                    <div className={styles.confirmBox}>
                      <p>¿restore a {currentUser.name} ({currentUser.username})?</p>
                      <div className={styles.buttonGroup}>
                        <button onClick={() => restoreUser(currentUser.id)} className={styles.button}>Sí, restore</button>
                        <button onClick={closeModal} className={styles.smallButton}>Cancelar</button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/** Roles */}
              {(modalOpen === 'createRole') && (
                <form onSubmit={submitRole} className={styles.form}>
                  <h3>Crear un nuevo rol</h3>
                  <input name="name" placeholder="Nombre" onChange={handleRoleChange} required />
                  <button type="submit" className={styles.button}>Guardar</button>
                </form>
              )}

              {(modalOpen === 'editRole') && (
                <div className={styles.form}>
                  <h3>Buscar</h3>
                  <form onSubmit={getFilteredRoles} className={styles.form}>
                    <input
                      placeholder="Buscar rol..."
                      value={searchRolesTerm}
                      onChange={(e) => setSearchRolesTerm(e.target.value)}
                    />
                    <button type="submit" className={styles.button}>Buscar</button>

                  </form>
                  {rolesFiltered != null &&
                    <h4>Última búsqueda:</h4>
                  }

                  <ul className={styles.list}>
                    {rolesFiltered.map(u => (
                      <li key={u.id} className={styles.listItem}>
                        <span>{u.name}</span>
                        <button
                          onClick={() => setCurrentRole(u)}
                          className={styles.smallButton}
                        >
                          Seleccionar
                        </button>
                      </li>
                    ))}
                  </ul>
                  {currentRole.id && (
                    <form onSubmit={submitRoleUpdate} className={styles.form}>
                      <h3>Editando</h3>
                      <input
                        name="name"
                        placeholder="Nombre"
                        value={currentRole.name || ''}
                        onChange={handleRoleChange}
                        required
                      />
                      <button type="submit" className={styles.button}>Guardar</button>
                    </form>
                  )}
                </div>
              )}

              {modalOpen === 'softdeleteRole' && (
                <div className={styles.form}>
                  <h3>Eliminar</h3>
                  <form onSubmit={getFilteredRoles} className={styles.form}>
                    <input
                      placeholder="Buscar rol..."
                      value={searchRolesTerm}
                      onChange={(e) => setSearchRolesTerm(e.target.value)}
                    />
                    <button type="submit" className={styles.button}>Buscar</button>

                  </form>


                  {rolesFiltered != null &&
                    <h4>Última búsqueda:</h4>
                  }

                  <ul className={styles.list}>
                    {rolesFiltered.map(u => (
                      <li key={u.id} className={styles.listItem}>
                        <span>{u.name}</span>
                        <button
                          onClick={() => setCurrentRole(u)}
                          className={styles.smallButton}
                        >

                          Seleccionar
                        </button>
                      </li>
                    ))}
                  </ul>
                  {currentRole.id && (
                    <div className={styles.confirmBox}>
                      <p>¿Eliminar el rol {currentRole.name}?</p>
                      <div className={styles.buttonGroup}>
                        <button onClick={() => deleteRole(currentRole.id)} className={styles.button}>Sí, eliminar</button>
                        <button onClick={closeModal} className={styles.smallButton}>Cancelar</button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {modalOpen === 'restoreRole' && (
                <div className={styles.form}>
                  <h3>Restaurar</h3>
                  <form onSubmit={getFilteredRoles} className={styles.form}>
                    <input
                      placeholder="Buscar rol..."
                      value={searchRolesTerm}
                      onChange={(e) => handleRoleChange(e)}
                    />
                    <button type="submit" className={styles.button}>Buscar</button>

                  </form>

                  {rolesFiltered != null &&
                    <h4>Última búsqueda:</h4>
                  }

                  <ul className={styles.list}>
                    {rolesFiltered.map(u => (
                      <li key={u.id} className={styles.listItem}>
                        <span>{u.name}</span>
                        <button
                          onClick={() => setCurrentRole(u)}
                          className={styles.smallButton}
                        >

                          Seleccionar
                        </button>
                      </li>
                    ))}
                  </ul>
                  {currentRole.id && (
                    <div className={styles.confirmBox}>
                      <p>¿Restaurar el rol {currentRole.name} (ID: {currentRole.id})?</p>
                      <div className={styles.buttonGroup}>
                        <button onClick={() => restoreRole(currentRole.id)} className={styles.button}>Sí, restaurar</button>
                        <button onClick={closeModal} className={styles.smallButton}>Cancelar</button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/** Organizations */}
              {(modalOpen === 'createOrganization') && (
                <form onSubmit={submitOrganization} className={styles.form}>
                  <h3>Crear una nueva organización </h3>
                  <input name="name" placeholder="Nombre" onChange={handleOrganizationChange} required />
                  <button type="submit" className={styles.button}>Guardar</button>
                </form>
              )}


              {(modalOpen === 'editOrganization') && (
                <div className={styles.form}>
                  <h3>Buscar</h3>
                  <form onSubmit={getFilteredOrganizations} className={styles.form}>
                    <input
                      placeholder="Buscar organización..."
                      value={searchOrganizationTerm}
                      onChange={(e) => setSearchOrganizationsTerm(e.target.value)}
                    />
                    <button type="submit" className={styles.button}>Buscar</button>


                  </form>
                  {organizationsFiltered != null &&
                    <h4>Última búsqueda:</h4>
                  }

                  <ul className={styles.list}>
                    {organizationsFiltered.map(u => (
                      <li key={u.id} className={styles.listItem}>
                        <span>{u.name}</span>
                        <button
                          onClick={() => setCurrentOrganization(u)}
                          className={styles.smallButton}
                        >
                          Seleccionar
                        </button>
                      </li>
                    ))}
                  </ul>
                  {currentOrganization.id && (
                    <form onSubmit={submitOrganizationsUpdate} className={styles.form}>
                      <h3>Editando</h3>
                      <input
                        name="name"
                        placeholder="Nombre"
                        value={currentOrganization.name || ''}
                        onChange={handleOrganizationChange}
                        required
                      />
                      <button type="submit" className={styles.button}>Guardar</button>
                    </form>
                  )}
                </div>
              )}


              {modalOpen === 'softdeleteOrganization' && (
                <div className={styles.form}>
                  <h3>Eliminar</h3>
                  <form onSubmit={getFilteredOrganizations} className={styles.form}>
                    <input
                      placeholder="Buscar organización..."
                      value={searchOrganizationTerm}
                      onChange={(e) => setSearchOrganizationsTerm(e.target.value)}
                    />
                    <button type="submit" className={styles.button}>Buscar</button>


                  </form>
                  {organizationsFiltered != null &&
                    <h4>Última búsqueda:</h4>
                  }
                  <ul className={styles.list}>
                    {organizationsFiltered.map(u => (
                      <li key={u.id} className={styles.listItem}>
                        <span>{u.name}</span>
                        <button
                          onClick={() => setCurrentOrganization(u)}
                          className={styles.smallButton}
                        >


                          Seleccionar
                        </button>
                      </li>
                    ))}
                  </ul>
                  {currentOrganization.id && (
                    <div className={styles.confirmBox}>
                      <p>¿Eliminar la organización {currentOrganization.name}?</p>
                      <div className={styles.buttonGroup}>
                        <button onClick={() => deleteOrganization(currentOrganization.id)} className={styles.button}>Sí, eliminar</button>
                        <button onClick={closeModal} className={styles.smallButton}>Cancelar</button>
                      </div>
                    </div>
                  )}
                </div>
              )}


              {modalOpen === 'restoreOrganization' && (
                <div className={styles.form}>
                  <h3>Restaurar</h3>
                  <form onSubmit={getFilteredOrganizations} className={styles.form}>
                    <input
                      placeholder="Buscar rol..."
                      value={searchOrganizationTerm}
                      onChange={(e) => handleOrganizationChange(e)}
                    />
                    <button type="submit" className={styles.button}>Buscar</button>


                  </form>
                  {organizationsFiltered != null &&
                    <h4>Última búsqueda:</h4>
                  }
                  <ul className={styles.list}>
                    {organizationsFiltered.map(u => (
                      <li key={u.id} className={styles.listItem}>
                        <span>{u.name}</span>
                        <button
                          onClick={() => setCurrentOrganization(u)}
                          className={styles.smallButton}
                        >


                          Seleccionar
                        </button>
                      </li>
                    ))}
                  </ul>
                  {currentOrganization.id && (
                    <div className={styles.confirmBox}>
                      <p>¿Restaurar la organización {currentOrganization.name} (ID: {currentOrganization.id})?</p>
                      <div className={styles.buttonGroup}>
                        <button onClick={() => restoreOrganization(currentOrganization.id)} className={styles.button}>Sí, restaurar</button>
                        <button onClick={closeModal} className={styles.smallButton}>Cancelar</button>
                      </div>
                    </div>
                  )}
                </div>
              )}


            </div>
          </div>
        )}
      </div>
    </div>
  )
};

export default Administrador;